(function () {
    'use strict';

    angular
    .module('szallodak-newsletter', ['angularjs-dropdown-multiselect', 'ui.bootstrap', 'ngMessages']);
})();
